// extracted by mini-css-extract-plugin
export default {"wrapper__outer":"stepper_wrapper__outer__PC0R9","wrapper__content":"stepper_wrapper__content__g+9O6"};